module.exports = __webpack_public_path__ + "dbfe67fcf64588c7bee5f74de9544f8d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SV.svg
// module id = J0DB
// module chunks = 0